/*!
 * Copyright © 2025. Verizon Connect. All rights reserved.
 */

export enum EUserType {
  None = 0,
  User = 1,
  Administrator = 2,
  Integration = 3,
  RegionalAdmin = 4,
  FleetCareAdmin = 5
}
